export default [
    {
        dimension: "a4",
        label: "A4 - 30cm x 21cm x 2cm",
        length: 30,
        width: 21,
        height: 2
    },
    {
        dimension: "a3",
        label: "A3 - 42cm x 30cm x 2cm",
        length: 42,
        width: 30,
        height: 2
    },
    {
        dimension: "a2",
        label: "A2 - 60cm x 42cm x 2cm",
        length: 60,
        width: 42,
        height: 2
    },
    {
        dimension: "a1",
        label: "A1 - 84cm x 60cm x 2cm",
        length: 84,
        width: 60,
        height: 2
    }
];
